'use strict';

var self = module.exports = {

  init: function () {

    /************************************************************************************************************************
     * Inizializza la gallery
     /***********************************************************************************************************************/

    /**
     * Inizializza la gallery degli elementi cavolo
     *
     * @plugin
     */
    $('.gallery-cabbage__carousel').owlCarousel({
      callbacks: true,
      center: true,
      dots: false,
      lazyLoad: false,
      loop: true,
      nav: true,
      navContainer: '.gallery-cabbage__nav',
      navElement: 'div class="gallery-cabbage__controls carousel__controls"',
      navText: false,
      rewind: false,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 4
        },
        1680: {
          items: 6
        }
      }
    });

    /**
     * Link applicato su ogni elemento cavolo
     * scatena la funzione 'choose' solamente
     * se il cavolo è selezionato al centro della gallery
     * altrimenti muove il carousel in base al cavolo selezionato
     */
    $('[data-js="cabbage-link-choose"]').click(function() {

      var $move = $(this).closest('.cabbage').attr('data-position');

      if ($(this).closest('.center').length > 0) {
        self.choose();
      }

      $('.gallery-cabbage__carousel').trigger('to.owl.carousel', $move);

    });

    /**
     * Button che scatena la funzione 'choose'
     */
    $('[data-js="cabbage-button-choose"]').click(function() {
      self.choose();
    });

  },
  choose: function () {

    /************************************************************************************************************************
     * Choose
     /***********************************************************************************************************************/

    var $canvas = $('.canvas'),
      $canvasWidth = $canvas.width(),
      $canvasHeight = $canvas.height(),
      $itemChoose = $('.gallery-cabbage').find('.center'),
      $cabbageTag = $itemChoose.find('.cabbage').data('tag'),
      $cabbageOriginalWidth = $itemChoose.find('.cabbage').data('original-width'),
      $cabbageOriginalHeight = $itemChoose.find('.cabbage').data('original-height'),
      $cabbage = $canvas.find('.draggable_theme_cabbage');

    $cabbage
      .attr('data-tag', $cabbageTag)
      .data('tag', $cabbageTag)
      .find('.draggable__image')
      .attr('src', '/media/cache/small/media/items/images/' + $cabbageTag + '.png');
    $cabbage
      .find('.draggable__item')
      .attr({
        'data-original-width': $cabbageOriginalWidth,
        'data-original-height': $cabbageOriginalHeight
      });

    var $cabbageWidth = $cabbage.width(),
      $cabbageHeight = $cabbage.height();

    $cabbage
      .css({
        position: 'absolute',
        top: Math.round(((($canvasHeight - $cabbageHeight) / 2) * 100) / $canvasHeight) + '%',
        left: Math.round(((($canvasWidth - $cabbageWidth) / 2) * 100) / $canvasWidth) + '%'
      })
      .find('.draggable__item')
      .data({
        'position-top': $cabbage.position().top,
        'position-left': $cabbage.position().left
      });

    $.fn.fullpage.moveSectionDown();

    $('#modal-help').foundation('open');

    global.artworkId = null;

    $.post('/artwork-save', {
      artworkId: global.artworkId,
      isModified: 0
    }, function(output) {
      if (output.error) {
        console.log('Ops! Qualcosa è andato storto!');
      } else {
        global.artworkId = output.id
      }
      console.log(output);
    });
  }
}

self.init();
